<script>
    export let labelText
    export let labelText2
    export let searchFunction
    export let criteria
    export let criteria2
</script>

<section>
<div class="criterias">
    <input bind:value={criteria} placeholder={labelText}/>
    {#if labelText2}
        <input bind:value={criteria2} placeholder={labelText2}/>
    {/if}
</div>
    <div class="magnifier" on:click={searchFunction}></div>
</section>

<style>
    .criterias {
        display: flex;
        flex-direction: column;
        gap: 10px;
        margin: 10px;
    }
    p {
        display: inline-flex;
        margin: 10px;
        min-width: 120px;
    }

    section {
        display: flex;
        align-items: center;
        margin: 12px auto;
        width: fit-content;
        border-top: 2px solid black;
        border-bottom: 2px solid black;
    }

    input {
        margin: 0;
        font-size: 0.8rem;
        width: 38ch;
    }

    .magnifier {
        background-image: url("../assets/magnifier.svg");
        background-repeat: no-repeat;
        width: 33px;
        border: 2px solid black;
        margin: 10px;
        aspect-ratio: 1;
        background-position: 2px 2px;
        display: inline-flex;
        box-sizing: border-box;
        box-shadow: 1px 1px;
    }

    .magnifier:active {
        transform: translate(1px, 1px);
        box-shadow: 0 0;
    }
</style>
<!--<div class="search-bar">-->
<!--    <p>{labelText}</p>-->
<!--    <input type="text" bind:value={criteria}/>-->
<!--    <div class="magnifier" on:click={() => searchFunction(criteria)}>-->
<!--    </div>-->
<!--</div>-->

<!--<style>-->
<!--    p {-->
<!--        margin-right: 1rem;-->
<!--        width: 120px;-->
<!--    }-->

<!--    .search-bar {-->
<!--        border-bottom: solid 2px;-->
<!--        justify-content: center;-->
<!--        align-items: center;-->
<!--        margin: 0 auto;-->
<!--    }-->

<!--    input {-->
<!--        font-size: 1rem;-->
<!--        padding: 0;-->
<!--        margin: 0 10px 0 0;-->
<!--        width:200px;-->
<!--    }-->

<!--    .magnifier {-->
<!--        user-select: none;-->
<!--        margin: 0 auto;-->
<!--        background-image: url("../assets/magnifier.svg");-->
<!--        background-size: 80%;-->
<!--        background-position: 2px 2px;-->
<!--        background-repeat: no-repeat;-->
<!--        width: 35px;-->
<!--        aspect-ratio: 1;-->
<!--        display: flex;-->
<!--        justify-content: center;-->
<!--        align-items: center;-->
<!--        border: solid 2px;-->
<!--        box-shadow: 2px 2px;-->
<!--        cursor: pointer;-->
<!--    }-->

<!--    .magnifier:active {-->
<!--        transform: translate(2px, 2px);-->
<!--        box-shadow: 0 0;-->
<!--    }-->
<!--</style>-->
